/**
 * Private modules
 */
const {
  createQueryComponent,
  customerId,
  objectIds,
  systemGameId,
} = require('../.private').components;

/**
 * Scopes
 */
const {
  CUSTOMER_SYSTEM_GAME_TYPES_INPUT_BY_SYSTEM_GAME_ID,
  DEFAULT,
} = require('../../scopes');

module.exports = {
  activateCustomerSystemGameTypesBySystemGameId: {
    properties: {
      body: {
        properties: {
          objectIds,
        },
        required: ['objectIds'],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  deactivateCustomerSystemGameTypesBySystemGameId: {
    properties: {
      body: {
        properties: {
          objectIds,
        },
        required: ['objectIds'],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  getCustomerSystemGameTypesBySystemGameId: {
    properties: {
      params: {
        properties: {
          customerId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
        ],
        type: 'object',
      },
      query: createQueryComponent([
        CUSTOMER_SYSTEM_GAME_TYPES_INPUT_BY_SYSTEM_GAME_ID,
        DEFAULT,
      ]),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
};
